// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fq","advertDetailServiceList__header":"c-o_fr","advertDetailServiceList__list":"c-o_fs"};